export const environment = {
  production: true,
  baseUrl: 'https://api-manantialomar.addcketstudio.com/api/'
};
